import React from "react";
import { Link } from "react-router-dom";
import { FaUserTie } from "react-icons/fa";

const AudienciasPublicas = () => {
  return (
    <div>
      <h1>AudienciasPublicas</h1>
    </div>
  );
};

export default AudienciasPublicas;
